import Vue from "vue";

Vue.filter(
  'kendoFormat',
  (data, format) => {
    return window.kendo.toString(data, format)
  },
);

Vue.filter(
  'stringToNumber',
  (data) => {
    if (!data) {
      return data;
    }

    if (typeof data === 'string' || data instanceof String) {
      try {
        let number = Number(data);
        if (!isNaN(number)) {
          return number;
        }
      }
      catch (error) {}
    }

    return data;
  }
);

Vue.filter(
  'stringToDate',
  (data) => {
    if (!data) {
      return data;
    }

    if (typeof data === 'string' || data instanceof String) {
      try {
        return new Date(data);
      }
      catch (error) {}
    }

    return data;
  }
);

Vue.filter(
  'phone',
  (data) => {
    if (!data) {
      return data;
    }
    if (data.length > 8) {
      // Force to only 8 charactes, remove 502
      return data.slice(-8);
    }

    return data;
  }
);

Vue.filter('two_digits', (value) => {
  if (value.toString().length <= 1) {
    return "0" + value.toString();
  }
  return value.toString();
});

Vue.filter(
  'limitedTextLength',
  (data, maxLength) => {
    if (!data) {
      return data;
    }
    if (data.length > maxLength) {
      // Cut the text and add ... at the end
      let newText = data.slice(0, maxLength - 2);
      newText += '...';
      return newText;
    }

    return data;
  }
);